import { getFormatStandardDate } from "../../utils/helpers/date";

export const CategoryProductOption: any = {
    chart: {
      type: "pie",
    },
    title: {
      text: 'Product Orders By Category',
      align: 'left',
    },
};